export const notEmitedProducts = {
	title: "Productos no emitidos",
	activeTab: "not-emited-products",
	export: "Exportar Excel",
	sheet: {
		title: "Productos no emitidos",
		filename: "productos_no_emitidos",
		columns: {
			name: "Producto",
			count: "Cantidad",
			combo: "Combo",
			firstNotEmittedSellDate: "Primer día no emitido",
			lastNotEmittedSellDate: "Último día no emitido",
		},
	},
	columns: {
		name: "Producto",
		count: "Cantidad",
		combo: "Combo",
		firstNotEmittedSellDate: "Primer día no emitido",
		lastNotEmittedSellDate: "Último día no emitido",
	},
};
